import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "permanina_beta_banner_dismissed_v1";

export function BetaBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (!dismissed) setVisible(true);
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="beta-banner"
      className="w-full bg-[#FFF8F0] border-b border-[#EFE3D2]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 sm:gap-4 font-ui text-xs sm:text-sm text-[#1A362D]">
        <span
          aria-hidden
          className="hidden sm:inline-flex items-center px-2 py-0.5 rounded-full bg-[#C05C45] text-white text-[10px] font-semibold tracking-wide uppercase shrink-0"
        >
          Beta
        </span>
        <p className="flex-1 leading-snug">
          <span className="font-semibold text-[#C05C45] sm:hidden">Beta · </span>
          Stiamo costruendo Per manina con la community.{" "}
          <Link
            to="/suggerisci"
            data-testid="beta-banner-cta"
            className="underline font-medium hover:text-[#C05C45]"
          >
            Segnalaci una scuola mancante o un errore
          </Link>
          .
        </p>
        <button
          type="button"
          onClick={dismiss}
          data-testid="beta-banner-close"
          aria-label="Chiudi avviso beta"
          className="text-[#8A9691] hover:text-[#1A362D] transition-colors shrink-0 p-1"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
